module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6x7gi"))).then(() => parcelRequire('1iHdE'));